import { useNavigation } from '@innovamat/ga-features';

type UseDrawerNavigationProps = {
  onOpenModifyModal?: () => void;
};

export const useDrawerNavigation = ({
  onOpenModifyModal,
}: UseDrawerNavigationProps) => {
  const { navigateInSameNavType } = useNavigation();

  const handlePersonalizeLinkClick = (): void => {
    if (onOpenModifyModal) {
      onOpenModifyModal();
    }
  };

  const handleReportLinkClick = (): void => {
    navigateInSameNavType('/reports/weekly-results');
  };

  return {
    handlePersonalizeLinkClick,
    handleReportLinkClick,
  };
};
